import {
  Assignment,
  Redeem,
  ScaleOutlined,
  WorkOutlineTwoTone,
} from "@mui/icons-material";
import HandymanIcon from "@mui/icons-material/Handyman";
import { Box, Stack } from "@mui/material";

import {
  capitalizeFirst,
  formatText,
  formatWeightLb,
  getCommdityNameForCondensedShipmentShipment,
  getServiceTypeDisplayLabel,
} from "utils";

import { ShipmentDetail } from "../../../Shipment/components/ShipmentDetail";
import { PublicCarrierInformationSection } from "../PublicCarrierInformationSection";
import { PublicShipperInformationSection } from "../PublicShipperInformationSection";

interface Props {
  shipment: PublicShipment | undefined;
}

export function PublicShipmentDetails(props: Props) {
  const { shipment } = props;

  const shipmentInfo = shipment?.info;
  const weightLb =
    shipmentInfo?.weight_lb != null
      ? parseFloat(shipmentInfo.weight_lb.toString())
      : null;
  const weightText =
    weightLb != null && Number.isFinite(weightLb)
      ? formatWeightLb(weightLb)
      : "-";

  return (
    <Stack direction="column" spacing={2}>
      <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
        <ShipmentDetail
          icon={<Redeem />}
          title="Commodity"
          text={
            shipment?.info
              ? capitalizeFirst(
                  formatText(
                    getCommdityNameForCondensedShipmentShipment(shipment.info),
                  ),
                )
              : "-"
          }
        />
        <ShipmentDetail
          icon={<ScaleOutlined fontSize="small" />}
          title="Weight"
          text={weightText}
        />
        <ShipmentDetail
          icon={<WorkOutlineTwoTone fontSize="small" />}
          title="Service"
          text={getServiceTypeDisplayLabel(shipmentInfo?.service ?? "-")}
        />
        <ShipmentDetail
          icon={<Assignment fontSize="small" />}
          title="Product Dimensions"
          multiline
          text={shipment?.info?.additional_details ?? "-"}
        />
        <ShipmentDetail
          icon={<HandymanIcon fontSize="small" />}
          title="Special Requirements"
          multiline
          text={shipment?.info?.special_requirements ?? "-"}
        />
      </Box>

      <Stack
        direction="row"
        spacing={3}
        flexWrap="wrap"
        sx={{ justifyContent: "space-between" }}
      >
        <PublicShipperInformationSection shipment={shipment} />
        <PublicCarrierInformationSection shipment={shipment} />
      </Stack>
    </Stack>
  );
}
